import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import SubscriptionComp from "../../Components/SubscriptionComp";
import Loader from "../../loader";

const Subscription = () => {
  return (
    <>
      {/* <Header /> */}
      <SubscriptionComp />
    </>
  );
};

export default Subscription;
